<template>
	<!-- 机构持股, 新版H5/英文版本 暂不开放 -->
	<MStateBox :loading="loading" :empty="isEmpty" class="act-container" ref="container">
		<van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onScrollPullDown">
			<div ref="layout">
				<div class="box-wrapper">
					<div class="dropdown-row">
						<m-dropdown :value.sync="dateValue" :options="dateList" @change="changeDrop"></m-dropdown>
					</div>
					<div v-html="renderTips" class="total-holdings-value"></div>
					<PieEchartComponent :orgData="orgData" />
					<div class="mobile-table-container">
						<MiniTable :data="tableList">
							<MiniTableColumn
								prop="institutionType"
								:label="i18n.t('enterprise.shareholder-institution')"
								width="160"
							>
								<template #default="{ row, rowIndex }">
									<div class="org-type-warp">
										<div :style="{ 'background': pieColor[rowIndex] }" class="org-type-dot"></div>
										<span>{{ row.institutionType }}</span>
									</div>
								</template>
							</MiniTableColumn>
							<MiniTableColumn prop="holdings" :label="i18n.t('enterprise.number-of-shares-held')">
								<template #default="{ row }">
									<span class="font-table-barlow">{{ formatterColTransferUnit(row.holdings) }}</span>
								</template>
							</MiniTableColumn>
							<MiniTableColumn
								prop="holdingsRatio"
								:label="i18n.t('enterprise.proportion-of-total-share-capital')"
							>
								<template #default="{ row }">
									<span class="font-table-barlow">{{
										!row.holdingsRatio ? '-' : `${Number(row.holdingsRatio).toFixed(2)}%`
									}}</span>
								</template>
							</MiniTableColumn>
						</MiniTable>
					</div>
				</div>
				<m-visible-tips fixed />
			</div>
		</van-pull-refresh>
	</MStateBox>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue';
import PieEchartComponent from '@/view/enterprise/components/pie-echart-component.vue';
import { formatterColTransferUnit } from '@/utils/enterprise';
import { getRect } from '@/utils/api';
import { PullRefresh as VanPullRefresh } from 'vant';
import { ZH_HK, EN, ZH } from '@/assets/js/i18n';
import i18n from '@/assets/js/i18n';
import moment from 'moment';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import MStateBox from '@rebuild/components/MStateBox.vue';
import { MiniTable, MiniTableColumn } from '@rebuild/components/table';

// 数据层
const { institutional_holding, institutional_holding_date } = useModuleData();

const isLoading = ref(false);
const renderTips = ref('');
const stockType = ref(1);
const dateValue = ref('');
const pieColor = ref(['#FF5260', '#FF7357', '#FFA05C', '#FFCA61', '#FFE666', '#6284EB', '#6BA3F2', '#7AD3FF', '', '']);

const container = ref(null);
const layout = ref(null);

// 保持与历史组件相同的数据访问路径
const dateList = computed(() => {
	const result = institutional_holding_date.data?.data || [];
	return result.map(v => ({
		text: v,
		value: moment(v).valueOf()
	}));
});

const orgData = computed(() => institutional_holding.data?.data || {});
const tableList = computed(() => orgData.value.data || []);

// 空状态判断
const isEmpty = computed(() => {
	return institutional_holding.empty || !dateList.value?.length;
});

const locale = computed(() => i18n.locale);

// 数据加载
async function loadData(value) {
	await institutional_holding.refresh({
		date: value
	});

	// 处理数据格式化
	const result = institutional_holding.data?.data || {};
	if (result.totalHoldingsRatio) {
		result.totalHoldingsRatio = result.totalHoldingsRatio.toFixed(2);
	}
	if (result.data) {
		result.data.forEach(item => {
			if (item.holdingsRatio) {
				item.holdingsRatio = item.holdingsRatio.toFixed(2);
			}
		});
	}

	const values = [result.totalHoldingsRatio ? result.totalHoldingsRatio + '%' : ''];
	renderTips.value = translateText(values[0]);
}

async function loadConfig() {
	await institutional_holding_date.refresh();

	if (dateList.value.length > 0) {
		dateValue.value = dateList.value[0].value;
		await loadData(dateList.value[0].text);
	}
	finish();
}

const loading = ref(true);
const finish = () => {
	loading.value = false;
};

async function onScrollPullDown() {
	await loadConfig();
	isLoading.value = false;
}

function changeDrop(value) {
	loadData(moment(value).format('YYYY-MM-DD'));
}

function translateText(value) {
	const translations = {
		[ZH]: `机构持股占总股本<span>${value}</span>`,
		[EN]: ``, // 机构持股  新版H5/英文版本 暂不开放
		[ZH_HK]: `機構持股佔總股本<span>${value}</span>`
	};

	return translations[locale.value];
}

onMounted(async () => {
	await loadConfig();
	nextTick(() => {
		const containerRect = getRect(container.value);
		if (layout.value) {
			layout.value.style.minHeight = `${containerRect.height}px`;
		}
	});
});
</script>

<style lang="less" scoped>
.act-container {
	height: 100%;
	background: #fff;

	.box-wrapper {
		padding: 0.16rem 0.14rem;
		background: #fff;
	}

	.dropdown-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.14rem;
	}

	.total-holdings-value {
		margin-bottom: 0.14rem;
		color: #000;
		/* 12/B1-regular */
		font-family: 'PingFang SC';
		font-size: 0.12rem;
		font-style: normal;
		font-weight: 400;
		line-height: 140%; /* 16.8px */

		/deep/ span {
			color: var(--ir-theme-color);
			margin-left: 0.04rem;
		}
	}

	.org-type-warp {
		display: flex;
		align-items: center;

		.org-type-dot {
			flex: none;
			margin-right: 0.12rem;
			width: 0.06rem;
			height: 0.06rem;
		}
	}
}
</style>
